import { useOrderTable } from "Order/Components/Tables/Hooks/useOrdersListTable";
import { Table } from "Shared/Components/Table/index";

type PartnerOrdersTabProps = {
	partnerId: number;
};

export function PartnerOrdersTab({ partnerId }: PartnerOrdersTabProps) {
	const tableOptions = useOrderTable({ partnerId });

	return <Table tableOptions={tableOptions} />;
}
